/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'beer': {
    width: 60,
    height: 60,
    viewBox: '0 0 60 60',
    data: '<path pid="0" d="M38 56h2a5 5 0 005-5V23M34 56h2M13 23v28c0 2.761 1.239 5 4 5h15M34 12a7 7 0 00-7-7c-2.732 0-5.107 1.582-6.26 3.864M44.333 19.498A7 7 0 0040 7c-1.379 0-2.576.459-3.647 1.247" _stroke="#000230" stroke-width="2" stroke-miterlimit="10"/><path pid="1" d="M23.97 13.872A6.5 6.5 0 1017.5 21h1a2.5 2.5 0 012.365 3.312l-1.622 4.726a4.5 4.5 0 108.514 0l-1.621-4.722A2.503 2.503 0 0128.5 21H32a2 2 0 011.613 3.182 3 3 0 104.774 0A2 2 0 0140 21h1M29 52V38M37 52V38M21 52V38M45 27h7a2 2 0 012 2v17a2 2 0 01-2 2h-7" _stroke="#000230" stroke-width="2" stroke-miterlimit="10"/><path pid="2" d="M50 34v10h-5M45 31h6" _stroke="#000230" stroke-width="2" stroke-miterlimit="10"/>'
  }
})
